<script lang="ts">
  import { CheckCircle } from "svelte-hero-icons";

  export let stepNumber: number = 0;
  export let state: "default" | "active" | "done" | "error";
  export let title: string = "";

  let hasContent = $$slots.default;
</script>

{#if state === 'default'}
  <li class="-ml-4 w-full flex flex-row items-center flex-wrap">
    <div
      class="w-8 h-8 mr-4 border-2 rounded-full text-base font-bold bg-white ring-2 ring-white border-gray-200 text-gray-200 flex justify-center items-center -ml-px">
      {stepNumber}
    </div>
    {#if title}<span class="flex-1 text-gray-500">{title}</span>{/if}
    {#if hasContent}
      <div class={title ? 'w-full ml-12' : 'flex-1'}>
        <slot />
      </div>
    {/if}
  </li>
{:else if state === 'active'}
  <li class="-ml-6 w-full flex flex-row items-center flex-wrap">
    <div
      class="w-12 h-12 mr-2 border-4 rounded-full text-xl text-center font-bold bg-white ring-4 ring-white border-indigo-500 text-indigo-500 flex justify-center items-center -ml-px">
      {stepNumber}
    </div>
    {#if title}
      <span class="flex-1 text-indigo-500 font-medium">{title}</span>
    {/if}
    {#if hasContent}
      <div class={title ? 'w-full ml-14' : 'flex-1'}>
        <slot />
      </div>
    {/if}
  </li>
{:else if state === 'done'}
  <li class="-ml-4 w-full flex flex-row items-center flex-wrap">
    <CheckCircle
      class="w-8 h-8 mr-4 bg-white ring-2 ring-white -ml-px text-green-500" />
    {#if title}<span class="flex-1 text-green-500">{title}</span>{/if}
    {#if hasContent}
      <div class={title ? 'w-full ml-12' : 'flex-1'}>
        <slot />
      </div>
    {/if}
  </li>
{/if}
